export class PersistentMenuService {
    static $inject = ['ProfileCommandProcessor'];
    constructor(ProfileCommandProcessor) {
        'ngInject';
        this.ProfileCommandProcessor = ProfileCommandProcessor;
    }
    //Persistent Menu
    async savePersistentMenu(application, persistentMenu) {
        return (await this.ProfileCommandProcessor.sendProfileCommand(application, 'set', 'persistent-menu', 'application/vnd.lime.document-select+json', persistentMenu));
    }
    getPersistentMenu(application) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'get', 'persistent-menu');
    }
    deletePersistentMenu(application) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'delete', 'persistent-menu');
    }
}
PersistentMenuService.$inject = ['ProfileCommandProcessor'];
